import { render, staticRenderFns } from "./LiveProductListSheet.vue?vue&type=template&id=8104cb6a&scoped=true"
import script from "./LiveProductListSheet.vue?vue&type=script&lang=js"
export * from "./LiveProductListSheet.vue?vue&type=script&lang=js"
import style0 from "./LiveProductListSheet.vue?vue&type=style&index=0&id=8104cb6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8104cb6a",
  null
  
)

export default component.exports